/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TournamentSignupTeamResponseDto { 
    signupTeamResult?: TournamentSignupTeamResponseDto.SignupTeamResultEnum;
}
export namespace TournamentSignupTeamResponseDto {
    export type SignupTeamResultEnum = 'SUCCESS' | 'REGISTRATION_CLOSED' | 'MAX_PARTICIPANTS_REACHED' | 'TEAM_ALREADY_EXISTS';
    export const SignupTeamResultEnum = {
        Success: 'SUCCESS' as SignupTeamResultEnum,
        RegistrationClosed: 'REGISTRATION_CLOSED' as SignupTeamResultEnum,
        MaxParticipantsReached: 'MAX_PARTICIPANTS_REACHED' as SignupTeamResultEnum,
        TeamAlreadyExists: 'TEAM_ALREADY_EXISTS' as SignupTeamResultEnum
    };
}


